module.exports = __webpack_public_path__ + "img/icon-docs.5c8efe90.svg";